import React, { useState } from 'react';
import { isDocumentAttributeKey } from '../../utils/documentAttributes';

const FieldLibraryPanel = ({
  fieldLibrary,
  fieldLibraryCategories,
  fields,
  onAddField,
  addingKey,
}) => {
  const [search, setSearch] = useState('');
  const [collapsed, setCollapsed] = useState(true);

  return (
    <div className="field-library-section">
      <div
        className="field-library-header"
        onClick={() => setCollapsed(!collapsed)}
      >
        <span className="field-library-toggle">{collapsed ? '▸' : '▾'}</span>
        <h4>Field Library</h4>
      </div>
      {!collapsed && (
        <div className="field-library-body">
          <input
            type="text"
            className="field-library-search"
            placeholder="Search fields…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          {fieldLibraryCategories.map(cat => {
            // Document attributes are not addable fields; a category holding
            // only attributes ends up empty and is not rendered.
            const items = fieldLibrary.filter(
              li => !isDocumentAttributeKey(li.field_key) &&
                li.category === cat &&
                (search === '' ||
                  li.label.toLowerCase().includes(search.toLowerCase()) ||
                  li.field_key.toLowerCase().includes(search.toLowerCase()))
            );
            if (items.length === 0) return null;
            return (
              <div key={cat} className="field-library-category">
                <div className="field-library-category-label">{cat}</div>
                {items.map(li => {
                  const libKey = li.field_key;
                  const existing = fields.find(f => f.field_key === libKey);
                  const isAdded = existing && existing.enabled !== false;
                  const isDisabled = existing && existing.enabled === false;
                  const isAdding = addingKey === libKey;
                  return (
                    <div key={libKey} className="field-library-item">
                      <div className="field-library-item-info">
                        <span className="field-library-item-label">{li.label}</span>
                        <span className="field-library-item-type">{li.value_type}</span>
                      </div>
                      {isAdding ? (
                        <button className="btn btn-xs" disabled>…</button>
                      ) : isAdded ? (
                        <span className="field-library-added-badge">Added</span>
                      ) : isDisabled ? (
                        <span className="field-library-added-badge" style={{ background: '#fef3c7', color: '#92400e' }}>Disabled</span>
                      ) : (
                        <button
                          className="btn btn-xs btn-primary"
                          onClick={() => onAddField(li)}
                        >
                          + Add
                        </button>
                      )}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FieldLibraryPanel;
